import { render, staticRenderFns } from "./c_page_ueditor.vue?vue&type=template&id=0b265648&scoped=true&"
import script from "./c_page_ueditor.vue?vue&type=script&lang=js&"
export * from "./c_page_ueditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b265648",
  null
  
)

export default component.exports